import { render, staticRenderFns } from "./editaddress.vue?vue&type=template&id=5c9e2fc5"
import script from "./editaddress.vue?vue&type=script&lang=js"
export * from "./editaddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports